import React from 'react';
import {
  ArrowRight,
  CheckMark,
  Lock,
} from '@shared/Resources/shared/components/OverviewListItem/components/OverviewBaseListItem/styles';

interface ProgressIconProps {
    isAccessible: boolean
    isCurrent: boolean
}

export const ProgressIcon:React.FC<ProgressIconProps> = ({ isAccessible, isCurrent }) => {
  if (isCurrent) {
    return <ArrowRight />;
  }
  if (!isAccessible) {
    return <Lock />;
  }
  return null;
};

export const CompletionIcon = ({ hasPassed }: { hasPassed: boolean }) => (
  hasPassed ? <CheckMark /> : null
);
